import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PharmasNextEra from "@/pages/PharmasNextEra";

export const Route = createFileRoute("/en/pharmas-next-era")({
  head: () =>
    buildRouteHead("/en/pharmas-next-era", {
      title: "Pharma's Next Era: AI, Biotech Innovation & the China Factor | QbD Group",
      description:
        "An exclusive executive roundtable and private lunch hosted by QbD Group at its Wilrijk HQ on Wednesday, 15 October 2026. Capped at 12 guests.",
    }),
  component: PharmasNextEra,
});
